import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

// Connect to emulators in development.
// Los puertos son configurables porque los de por defecto chocan con otros
// proyectos (p.ej. 8080). Sin las variables, se usan los de siempre.
if (import.meta.env.VITE_USE_EMULATORS === "true") {
  const port = (name: string, fallback: number) =>
    Number(import.meta.env[`VITE_EMULATOR_${name}_PORT`]) || fallback;
  connectAuthEmulator(auth, `http://localhost:${port("AUTH", 9099)}`);
  connectFirestoreEmulator(db, "localhost", port("FIRESTORE", 8080));
  connectStorageEmulator(storage, "localhost", port("STORAGE", 9199));
  connectFunctionsEmulator(functions, "localhost", port("FUNCTIONS", 5001));
  console.log("🔥 Connected to Firebase Emulators");
}

export default app;
